import { FaCalendarAlt, FaGithub, FaGlobe } from "react-icons/fa";
import "./Projects.css";

const Projects = () => {
  const projects = [
    {
      name: "Midnight Cookies",
      period: "05/2026 - Present",
      link: null,
      github: null,
      description: [
        "A full-stack cookie e-commerce platform I designed and built end to end on the MERN stack, covering both the customer storefront and an admin control panel.",
        "Integrated Razorpay for secure online payments and used Redis to cache hot data like product listings and featured cookies, keeping the store fast under load.",
        "Added real-time chat with Socket.io so customers can talk to the admin directly, plus a newsletter flow to keep buyers in the loop on new drops.",
      ],
      technologies: [
        "React",
        "Node.js",
        "Express.js",
        "MongoDB",
        "Redis",
        "Socket.io",
        "Razorpay",
      ],
      image: "/images/midnight-cookies.svg",
    },
    {
      name: "Avery Telehealth",
      period: "02/2023 - 10/2025",
      link: "https://actaverytelehealth.com/Login",
      github: null,
      description: [
        "Remote patient monitoring platform I worked on across the full stack, from the clinician-facing web dashboards down to the APIs feeding them.",
        "Pulled in live vitals from Indie Health Bluetooth devices and Apple HealthKit, so care teams could spot issues without waiting on manual check-ins.",
        "Added Twilio-driven SMS reminders and automated alerts that cut down a lot of the follow-up calls staff were making by hand.",
      ],
      technologies: [
        "React",
        "Node.js",
        "MongoDB",
        "Swift (iOS)",
        "Twilio",
        "AWS",
      ],
      image: "/images/avery_telehealth.png",
    },
    {
      name: "Goodie Bag",
      period: "10/2025 - 06/2026",
      link: "https://www.goodiebag.co/",
      github: null,
      description: [
        "A marketplace app that helps local vendors sell surplus food at a discount instead of throwing it out.",
        "Built the ordering flow end to end: sign-in, vendor listings, cart and checkout, plus the backend that keeps it all in sync.",
        "Handled image uploads and storage on AWS so vendors could manage their own listings without us in the loop.",
      ],
      technologies: ["Flutter", "Node.js", "PostgreSQL", "AWS"],
      image: "/images/goodie_bag.png",
    },
    {
      name: "CloudBuddi",
      period: "07/2026 - Present",
      link: "https://www.cloudbuddi.com/",
      github: null,
      description: [
        "An AWS cost-management tool that pulls billing and usage data together so teams can actually see where the money is going.",
        "Working on the dashboards and the services behind them that break spend down by account, service, and tag.",
      ],
      technologies: ["React", "Node.js", "AWS"],
      image: "/images/cloud-buddi.svg",
    },
    {
      name: "AppSquadz Websites & CMS",
      period: "07/2026 - Present",
      link: "https://www.appsquadz.com",
      github: null,
      description: [
        "Maintain the AppSquadz India and Dubai sites and keep them running day to day.",
        "Built a small CMS so the marketing team can swap banners and edit page sections themselves instead of filing a ticket for every change.",
      ],
      technologies: ["Next.js", "Node.js", "MongoDB"],
      image: "/images/appsquadz.svg",
    },
  ];

  // Parse the start date (the "MM/YYYY" before the dash) into a sortable value.
  const getStartDate = (period) => {
    const [start] = period.split("-");
    const [month, year] = start.trim().split("/").map(Number);
    return new Date(year, (month || 1) - 1);
  };

  // Show the most recent projects first.
  const sortedProjects = [...projects].sort(
    (a, b) => getStartDate(b.period) - getStartDate(a.period),
  );

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Featured Projects</h2>

        <div className="projects-grid">
          {sortedProjects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image">
                <img
                  src={project.image}
                  alt={project.name}
                  onError={(e) => {
                    e.target.style.display = "none";
                    const fallback = e.target.nextElementSibling;
                    if (fallback) fallback.style.display = "flex";
                  }}
                />
                <div className="project-image-fallback">
                  <span>{project.name}</span>
                </div>
                <div className="project-overlay">
                  <div className="project-links">
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                      >
                        <FaGlobe />
                      </a>
                    )}
                    {project.github && (
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                      >
                        <FaGithub />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="project-content">
                <div className="project-header">
                  <h3>{project.name}</h3>
                  <div className="project-meta">
                    <FaCalendarAlt className="icon" />
                    <span>{project.period}</span>
                  </div>
                </div>

                <ul className="project-description">
                  {project.description.map((desc, descIndex) => (
                    <li key={descIndex}>{desc}</li>
                  ))}
                </ul>

                <div className="project-technologies">
                  {project.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
